module.exports = __webpack_public_path__ + "img/bg-800.f9b9e3d4.jpg";